import { defineMessages } from 'react-intl';

const translations = {
  conversationList: {
    title: {
      id: 'conversationList.title',
      defaultMessage: 'Comments',
      description: 'Title of the comments list',
    },
    emptyMessage: {
      id: 'conversationList.emptyMessage',
      defaultMessage: 'No comments',
      description: 'Message of the empty comments list',
    },
    actions: {
      addComment: {
        id: 'conversationList.actions.addComment',
        defaultMessage: 'Add comment',
        description: 'Title of the action add comment',
      },
    },
    feedback: {
      conversationCreated: {
        id: 'conversationList.feedback.conversationCreated',
        defaultMessage: 'Conversation created',
        description: 'Conversation created success message',
      },
      conversationNotCreated: {
        id: 'conversationList.feedback.conversationNotCreated',
        defaultMessage: 'Conversation could not be created',
        description: 'Conversation create error message',
      },
    },
  },
};

export default defineMessages(translations);
